import { render, staticRenderFns } from "./TagCountList.vue?vue&type=template&id=653f6d10&scoped=true"
import script from "./TagCountList.vue?vue&type=script&lang=js"
export * from "./TagCountList.vue?vue&type=script&lang=js"
import style0 from "./TagCountList.vue?vue&type=style&index=0&id=653f6d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f6d10",
  null
  
)

export default component.exports